import React from 'react';
import { View, Pressable } from 'react-native';
import PropTypes from 'prop-types';
import Text from '@/components/Typography/Text';
import { reportWorkLaunchError } from '@/lib/reportWorkLaunchError';
import WorkStartupCompanion from './WorkStartupCompanion';
import { useWorkLive } from './WorkLiveContext';

export default function WorkLaunchWaitNotice({ waiting }) {
  const live = useWorkLive();
  if (!waiting) return null;
  return <View testID="work-launch-wait">
    <WorkStartupCompanion phase={waiting.startupPhase} prompt={live?.startupPrompt} startedAt={live?.liveStartTs} />
    {waiting.icon === 'coins' && <Pressable accessibilityRole="button" accessibilityLabel="Add credits"
      onPress={() => reportWorkLaunchError({ status: 402 }, { source: 'launch_wait' })} style={{ alignSelf: 'flex-start', marginLeft: 48, paddingVertical: 4 }}>
      <Text size="xs" weight="semibold">Add credits</Text>
    </Pressable>}
  </View>;
}
WorkLaunchWaitNotice.propTypes = { waiting: PropTypes.shape({ text: PropTypes.string, detail: PropTypes.string, icon: PropTypes.string, isStarting: PropTypes.bool, startupPhase: PropTypes.string }) };
